import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { NgxSpinnerComponent } from 'ngx-spinner'
import { ThemeService } from '@shared-services/theme.service'
import { LoadingService } from '@shared-services/loading.service'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'main-view',
  imports: [RouterOutlet, NgxSpinnerComponent],
  templateUrl: './main.view.html',
  styleUrl: './main.view.scss',
})
export class MainView {
  private readonly _themeService = inject(ThemeService)
  protected readonly _loading = inject(LoadingService)
}
